import { api } from '@/api';
import { handleQueryLifecycle } from '@/api/utils.ts';
import { setChatTitle, updateChatHistoryTitle } from '@/store';

export interface GenerateChatTitleRequest {
  chatId: string;
}

export interface GenerateChatTitleResponse {
  chatTitle: string;
}

export const generateChatTitleApi = api.injectEndpoints({
  endpoints: (builder) => ({
    generateChatTitle: builder.mutation<GenerateChatTitleResponse, GenerateChatTitleRequest>({
      query: ({ chatId }) => ({
        url: '/chat/generate-title',
        method: 'POST',
        body: {
          chat_id: chatId,
        },
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        await handleQueryLifecycle(queryFulfilled, ({ chatTitle }) => {
          dispatch(setChatTitle({ chatTitle }));
          dispatch(updateChatHistoryTitle({ chatId: arg.chatId, title: chatTitle }));
        });
      },
    }),
  }),
});
